/* eslint-disable */
// @ts-nocheck

import { initCollapsibleMobileMenus } from './init-collapsible-mobile-menus';

// Scripts used for Menu modules.
// This script is extracted from frontend-scripts to be used in Divi's Dynamic Assets system.
(function ($) {
  $(window).on('et_pb_init_modules', function () {
    window.et_pb_init_menu_modules = function () {
      // If we create a menu from the theme builder containing pages and categories,
      // the highlighter class is not added to the menu item, so we must manually add it.
      $('.et-menu').find('li.current-cat, li.current_page_item').addClass('current-menu-item');

      function menuModuleOpenSearch($module) {
        const $menu = $module.find('.et_pb_menu__wrap').first();
        const $search = $module.find('.et_pb_menu__search-container').first();
        const $input = $module.find('.et_pb_menu__search-input').first();
        const $fwMenuLogo = $module.find('.et_pb_row > .et_pb_menu__logo-wrap').first();
        const $menuLogo = $module.find('.et_pb_menu_inner_container > .et_pb_menu__logo-wrap').first();
        const $logo = $fwMenuLogo.add($menuLogo);
        const isMobile = $(window).width() <= 980;

        if ($search.hasClass('et_pb_is_animating')) {
          return;
        }

        // Close the menu if it is open.
        $menu.find('.mobile_nav.opened').removeClass('opened').addClass('closed');
        $menu.find('.et_mobile_menu').hide();

        $menu.removeClass('et_pb_menu__wrap--visible').addClass('et_pb_menu__wrap--hidden');
        $search
          .removeClass('et_pb_menu__search-container--hidden et_pb_menu__search-container--disabled')
          .addClass('et_pb_menu__search-container--visible et_pb_is_animating');

        // Adjust spacing based on layout and the logo used.
        $search.css('padding-top', '0px');
        if (
          $module.hasClass('et_pb_menu--style-left_aligned') ||
          $module.hasClass('et_pb_fullwidth_menu--style-left_aligned')
        ) {
          $search.css('padding-left', `${$logo.width()}px`);
        } else {
          const logoHeight = $logo.height();
          $search.css('padding-left', '0px');
          if (
            isMobile ||
            $module.hasClass('et_pb_menu--style-centered') ||
            $module.hasClass('et_pb_fullwidth_menu--style-centered')
          ) {
            // 30 = logo margin-bottom.
            $search.css('padding-top', `${logoHeight > 0 ? logoHeight + 30 : 0}px`);
          }
        }

        $input.css('font-size', $module.find('.et-menu-nav li a').first().css('font-size'));
        setTimeout(() => $input.trigger('focus'), 0);
        setTimeout(() => {
          $menu.addClass('et_pb_no_animation');
          $search.addClass('et_pb_no_animation').removeClass('et_pb_is_animating');
        }, 1000);
      }

      function menuModuleCloseSearch($module) {
        const $menu = $module.find('.et_pb_menu__wrap').first();
        const $search = $module.find('.et_pb_menu__search-container').first();
        const $input = $module.find('.et_pb_menu__search-input').first();

        if ($search.hasClass('et_pb_is_animating')) {
          return;
        }

        $menu.removeClass('et_pb_menu__wrap--hidden').addClass('et_pb_menu__wrap--visible');
        $search
          .removeClass('et_pb_menu__search-container--visible')
          .addClass('et_pb_menu__search-container--hidden et_pb_is_animating');
        $input.trigger('blur');

        setTimeout(() => {
          $search.removeClass('et_pb_is_animating').addClass('et_pb_menu__search-container--disabled');
        }, 1000);
      }

      function menuModuleCloneInlineLogo($module) {
        const $logo = $module.find('.et_pb_menu__logo-wrap').first();

        if (!$logo.length) {
          return;
        }

        const $menu = $module.find('.et_pb_menu__menu').first();

        if (!$menu.length || $menu.find('.et_pb_menu__logo').length > 0) {
          return;
        }

        const li = window.et_pb_menu_inject_inline_centered_logo($menu.get(0));

        if (li !== null) {
          $(li).empty().append($logo.clone());
        }
      }

      function addParentClassesForMenuWithDropdown() {
        $('.et_pb_menu .sub-menu, .et_pb_fullwidth_menu .sub-menu').each(function () {
          const $menu = $(this);

          // Traverse up and add class to the appropriate parent elements.
          const $column = $menu.closest('.et_pb_column');
          const $row = $menu.closest('.et_pb_row');
          const $section = $menu.closest('.et_pb_section');

          if ($column.length) {
            $column.addClass('et_pb_column--with-menu');
          }
          if ($row.length) {
            $row.addClass('et_pb_row--with-menu');
          }
          if ($section.length) {
            $section.addClass('et_pb_section--with-menu');
          }
        });
      }

      function disableTopTierDropdownMenuLinks() {
        const $disableTopTierMenu = $('ul.et_disable_top_tier');

        if (!$disableTopTierMenu.length) {
          return;
        }

        const $disabledTopTierLinks = $disableTopTierMenu.find('> li > ul').prev('a');

        $disabledTopTierLinks.attr('href', '#');
        $disabledTopTierLinks.on('click', e => {
          e.preventDefault();
        });

        // Handle top-tier links in duplicated mobile menus.
        const $disabledTopTierLinksMobile = $('ul.et_mobile_menu > li > ul').prev('a');

        $disabledTopTierLinksMobile.attr('href', '#');
        $disabledTopTierLinksMobile.on('click', e => {
          e.preventDefault();
        });
      }

      $(document).on('click', '.et_pb_menu__search-button', function () {
        menuModuleOpenSearch($(this).closest('.et_pb_module'));
      });

      $(document).on('click', '.et_pb_menu__close-search-button', function () {
        menuModuleCloseSearch($(this).closest('.et_pb_module'));
      });

      $(document).on('blur', '.et_pb_menu__search-input', function () {
        menuModuleCloseSearch($(this).closest('.et_pb_module'));
      });

      $('#et_top_search').on('click', function () {
        const $search_container = $('.et_search_form_container');

        if ($search_container.hasClass('et_pb_is_animating')) {
          return;
        }

        $('.et_menu_container').removeClass('et_pb_menu_visible et_pb_no_animation').addClass('et_pb_menu_hidden');
        $search_container
          .removeClass('et_pb_search_form_hidden et_pb_no_animation')
          .addClass('et_pb_search_visible et_pb_is_animating');
        setTimeout(() => {
          $('.et_menu_container').addClass('et_pb_no_animation');
          $search_container.addClass('et_pb_no_animation').removeClass('et_pb_is_animating');
        }, 1000);
        $search_container.find('input').trigger('focus');
        et_set_search_form_css();
      });

      function et_hide_search() {
        if ($('.et_search_form_container').hasClass('et_pb_is_animating')) {
          return;
        }

        $('.et_menu_container').removeClass('et_pb_menu_hidden et_pb_no_animation').addClass('et_pb_menu_visible');
        $('.et_search_form_container')
          .removeClass('et_pb_search_visible et_pb_no_animation')
          .addClass('et_pb_search_form_hidden et_pb_is_animating');
        setTimeout(() => {
          $('.et_menu_container').addClass('et_pb_no_animation');
          $('.et_search_form_container').addClass('et_pb_no_animation').removeClass('et_pb_is_animating');
        }, 1000);
      }

      function et_set_search_form_css() {
        const $search_container = $('.et_search_form_container');
        const $body = $('body');

        if ($search_container.hasClass('et_pb_search_visible')) {
          const header_height = $('#main-header').innerHeight();
          const menu_width = $('#top-menu').width();
          const font_size = $('#top-menu li a').css('font-size');
          $search_container.css({ height: `${header_height}px` });
          $search_container.find('input').css('font-size', font_size);

          if (!$body.hasClass('et_header_style_left')) {
            $search_container.css('max-width', `${menu_width + 60}px`);
          } else {
            $search_container.find('form').css('max-width', `${menu_width + 60}px`);
          }
        }
      }

      $('.et_close_search_field').on('click', function () {
        et_hide_search();
      });

      et_duplicate_menu(
        $('#et-top-navigation ul.nav'),
        $('#et-top-navigation .mobile_nav'),
        'mobile_menu',
        'et_mobile_menu',
      );
      et_duplicate_menu(
        '',
        $('.et_pb_fullscreen_nav_container'),
        'mobile_menu_slide',
        'et_mobile_menu',
        'no_click_event',
      );

      $(() => {
        $('.et_pb_menu--style-inline_centered_logo, .et_pb_fullwidth_menu--style-inline_centered_logo').each(
          function () {
            menuModuleCloneInlineLogo($(this));
          },
        );

        // Reload fitVids for iframes handled by lazysizes.
        if (typeof window.lazySizes !== 'undefined') {
          $(document).on('lazyloaded', e => {
            const $target = $(e.target);
            const targetName = $target.attr('name');

            // Target fitvid or unassigned iframe to ensure it has the correct source.
            if ($target.is('iframe') && (targetName.includes('fitvid') || typeof targetName === 'undefined')) {
              $target.attr('src', $target.attr('data-src'));
              $target.parent().fitVids();
            }
          });
        }
        $('.et-menu-nav ul.nav').each(function (i) {
          et_duplicate_menu(
            $(this),
            $(this).closest('.et_pb_module').find('div .mobile_nav'),
            `mobile_menu${i + 1}`,
            'et_mobile_menu',
          );
        });

        /**
         * Collapsible mobile submenus for Menu modules.
         *
         * Injects a single toggle button after et_duplicate_menu clones the nav,
         * then toggles `.et_pb_collapsible_menu_open` + aria-expanded. Icon glyph
         * swap is handled in CSS (open vs close ::before content).
         */
        // Expose for VB preview teardown so FE handlers can be re-bound.
        window.et_pb_init_collapsible_mobile_menus = initCollapsibleMobileMenus;

        initCollapsibleMobileMenus();

        disableTopTierDropdownMenuLinks();

        $('.et_pb_menu, .et_pb_fullwidth_menu').each(function () {
          const this_menu = $(this);
          const bg_color = this_menu.data('bg_color');
          if (bg_color) {
            this_menu.find('ul').css({ 'background-color': bg_color });
          }
        });

        // Adjust z-index for animated menu modules.
        if (typeof diviElementAnimationData !== 'undefined' && diviElementAnimationData.length > 0) {
          let maxMenuIndex = 0;

          // Increase the maximum z-index by one for each module
          for (let i = 0; i < diviElementAnimationData.length; i++) {
            const animation_entry = diviElementAnimationData[i];

            if (!animation_entry.class) {
              continue;
            }

            const $animationEntry = $(`.${animation_entry.class}`);

            if ($animationEntry.hasClass('et_pb_menu') || $animationEntry.hasClass('et_pb_fullwidth_menu')) {
              maxMenuIndex++;
            }
          }

          const $menus = $('.et_pb_menu, .et_pb_fullwidth_menu');

          $menus.each(function () {
            const $menu = $(this);

            // When the animation ends, apply z-index in descending order to each of the animated modules
            $menu.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', () => {
              $menu.css('z-index', maxMenuIndex - $menu.index('.et_pb_menu, .et_pb_fullwidth_menu'));
            });
          });
        }

        function et_fix_nav_direction() {
          const window_width = $(window).width();
          $('.nav li.et-reverse-direction-nav').removeClass('et-reverse-direction-nav');
          $('.nav li[data-reverse-reason]').removeAttr('data-reverse-reason');

          // Track which menu items need class for nested submenus vs first-level.
          // Using DOM element references for robustness (works across multiple menus).
          const nestedReverseItems = new Set();
          const firstLevelReverseItems = new Set();

          // Process nested submenus (second-level+) - matches D4 behavior.
          $('.nav li li ul').each(function () {
            const $dropdown = $(this);
            const dropdown_width = $dropdown.width();
            const dropdown_offset = $dropdown.offset();
            const $parents = $dropdown.parents('.nav > li');

            if (dropdown_offset.left > window_width - dropdown_width) {
              // Store DOM element reference for reliable tracking across multiple menus.
              const parentElement = $parents.first()[0];
              nestedReverseItems.add(parentElement);
            }
          });

          // Process first-level submenus - only when they overflow.
          $('.nav li > ul').each(function () {
            const $dropdown = $(this);
            const $parent = $(this).parent('.nav > li');
            const dropdown_width = $dropdown.width();
            const dropdown_offset = $dropdown.offset();

            // Only add class if first-level submenu would overflow viewport.
            if (dropdown_offset.left > window_width - dropdown_width) {
              // Store DOM element reference for reliable tracking across multiple menus.
              const parentElement = $parent[0];
              firstLevelReverseItems.add(parentElement);
            }
          });

          // Apply classes with appropriate data attributes.
          // data-reverse-reason values:
          // - "nested": Only nested submenu overflowed (applies nested CSS only).
          // - "first-level": Only first-level submenu overflowed (applies first-level CSS only).
          // - "both": Both nested and first-level overflowed (applies both CSS rules).
          $('.nav > li').each(function () {
            const $li = $(this);
            const liElement = $li[0];
            const hasNested = nestedReverseItems.has(liElement);
            const hasFirstLevel = firstLevelReverseItems.has(liElement);

            if (hasNested || hasFirstLevel) {
              $li.addClass('et-reverse-direction-nav');
              if (hasNested && hasFirstLevel) {
                $li.attr('data-reverse-reason', 'both');
              } else if (hasNested) {
                $li.attr('data-reverse-reason', 'nested');
              } else {
                $li.attr('data-reverse-reason', 'first-level');
              }
            }
          });
        }
        et_fix_nav_direction();

        // Call the new function to add classes to parent elements of menu modules.
        addParentClassesForMenuWithDropdown();

        // Apply z-index to rows with menu modules to show
        // the dropdowns above the immediate section if it has a box-shadow.
        $('.et_pb_row--with-menu').css({
          'z-index': '999',
          position: 'relative',
        });

        $(window).on('resize', et_fix_nav_direction);
        $(window).on('resize', window.et_pb_reposition_menu_module_dropdowns);
      });

      document.addEventListener('DOMContentLoaded', window.et_pb_reposition_menu_module_dropdowns);
    };

    window.et_pb_init_menu_modules();
  });
})(jQuery);
